export enum PdsrStateType {
  Active = 1,
  Expired = 2,
  New = 3,
}
